export enum PrintAreaName {
  Front = 'front',
  Back = 'back',

  NeckInner = 'neck-inner',
  NeckOuter = 'neck-outer',

  SleeveLeft = 'sleeve-left',
  SleeveRight = 'sleeve-right',
  // embroidery
  FrontEmbroidery = 'front-embroidery',
  BackEmbroidery = 'back-embroidery',

  ChestLeftEmbroidery = 'chest-left-embroidery',
  ChestCenterEmbroidery = 'chest-center-embroidery',
  ChestLargeEmbroidery = 'chest-large-embroidery',

  SleeveLeftEmbroidery = 'sleeve-left-embroidery',
  SleeveRightEmbroidery = 'sleeve-right-embroidery',

  WristLeftEmbroidery = 'wrist-left-embroidery',
  WristRightEmbroidery = 'wrist-right-embroidery',

  LeftEmbroidery = 'left-embroidery',
  RightEmbroidery = 'right-embroidery',

  BackLargeEmbroidery = 'back-large-embroidery',
  RightCornerEmbroidery = 'right-corner-embroidery',
  BottomCenterEmbroidery = 'bottom-center-embroidery',
  LargeRightCornerEmbroidery = 'large-right-corner-embroidery',
}

// this order is what GN expects to get in the design structure (i.e. pages order)
export const printAreaNamesSorted = [
  PrintAreaName.Front,
  PrintAreaName.Back,
  PrintAreaName.FrontEmbroidery,
  PrintAreaName.BackEmbroidery,
  PrintAreaName.ChestLeftEmbroidery,
  PrintAreaName.ChestCenterEmbroidery,
  PrintAreaName.ChestLargeEmbroidery,
  PrintAreaName.NeckInner,
  PrintAreaName.NeckOuter,
  PrintAreaName.SleeveLeft,
  PrintAreaName.SleeveRight,
  PrintAreaName.SleeveLeftEmbroidery,
  PrintAreaName.SleeveRightEmbroidery,
  PrintAreaName.WristLeftEmbroidery,
  PrintAreaName.WristRightEmbroidery,
  PrintAreaName.LeftEmbroidery,
  PrintAreaName.RightEmbroidery,
  PrintAreaName.BackLargeEmbroidery,
  PrintAreaName.RightCornerEmbroidery,
  PrintAreaName.BottomCenterEmbroidery,
  PrintAreaName.LargeRightCornerEmbroidery,
];

export const basePrintAreaNamesEmbroidery = [
  PrintAreaName.FrontEmbroidery,
  PrintAreaName.BackEmbroidery,
  PrintAreaName.ChestLeftEmbroidery,
  PrintAreaName.ChestCenterEmbroidery,
  PrintAreaName.ChestLargeEmbroidery,
  PrintAreaName.LeftEmbroidery,
  PrintAreaName.RightEmbroidery,
  PrintAreaName.BackLargeEmbroidery,
  PrintAreaName.RightCornerEmbroidery,
  PrintAreaName.BottomCenterEmbroidery,
  PrintAreaName.LargeRightCornerEmbroidery,
];

export const printAreasNamesForPriceBreakdown = [
  PrintAreaName.Front,
  PrintAreaName.Back,
  PrintAreaName.ChestLeftEmbroidery,
  PrintAreaName.ChestCenterEmbroidery,
  PrintAreaName.ChestLargeEmbroidery,
];
